/* eslint-disable @typescript-eslint/no-explicit-any */
import CustomTable from 'components/cmn/CustomTable';
import { CompAccountsTableHead } from 'components/cmn/CustomTableHeadWrapper';
import { useProject } from 'hooks/useProject';
import { memo, useEffect, useMemo } from 'react';
import CompAccountsTableBody from './CompAccountsTableBody';

function AccountsTable(): JSX.Element {
  const { getCompAccounts, changeAccountsPageAndSize, accountsListSearchCondition } = useProject();
  const { data, isLoading, duration } = getCompAccounts();
  const { page, size } = accountsListSearchCondition;

  const accountsData = useMemo(() => {
    return data?.contents || [];
  }, [data?.contents]);

  const totalCount = useMemo(() => {
    return data?.totalCount ?? 0;
  }, [data?.totalCount]);

  const handleChangePage = (event: unknown, newPage: number): any => {
    changeAccountsPageAndSize(newPage, size);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const _rowsPerPage = parseInt(event.target.value, 10);
    changeAccountsPageAndSize(0, _rowsPerPage);
  };

  useEffect(() => {
    if (page !== 0 && totalCount !== 0 && accountsData.length === 0) {
      changeAccountsPageAndSize(page - 1, size);
    }
  }, [changeAccountsPageAndSize, page, accountsData.length, size, totalCount]);

  return (
    <CustomTable
      count={totalCount}
      rowsPerPage={size}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      isLoading={isLoading}
      maxHeight="calc(100vh - 550px)"
      duration={duration}
    >
      <CompAccountsTableHead order="desc" orderBy="id" />
      <CompAccountsTableBody loading={isLoading} rows={accountsData} duration={duration} />
    </CustomTable>
  );
}

export default memo(AccountsTable);
